import { ErrorType, RequestErrorResponseFields, RequestErrorResponse } from './types'

export class NetworkRequestError extends Error {
    code: ErrorType
    fields: RequestErrorResponseFields
    message: string
    name: string

    constructor(code: ErrorType, fields: RequestErrorResponseFields, message: string) {
        super()

        this.code = code
        this.fields = fields
        this.name = 'NetworkRequestError'
        this.message = message
        
        Object.setPrototypeOf(this, new.target.prototype)
    }

    static createFromNetworkError(e: RequestErrorResponse) {
        return new NetworkRequestError(e.code, e.fields, e.message)
    }
}

export class BadRequestError extends Error {
    code: ErrorType
    fields: RequestErrorResponseFields
    message: string
    name: string

    constructor(fields: RequestErrorResponseFields, message: string) {
        super()

        this.code = 'invalid'
        this.fields = fields
        this.name = 'BadRequestError'
        this.message = message
        
        Object.setPrototypeOf(this, new.target.prototype)
    }
}
